import { defineStore, acceptHMRUpdate } from 'pinia'

export const useNavStore = defineStore('nav', {
  state: () => {
    return {
      loading: false,
      sidebarCollapsed: false,
      title: '',
      clientSide: false,
      showSearchBar: false,
    }
  },
  actions: {
    setTitle(title: string) {
      this.title = title
    },
    setClientSide(clientSide: boolean) {
      this.clientSide = clientSide
    },
    toggleSearchBar() {
      this.showSearchBar = !this.showSearchBar
    },
    setShowSearchBar(value: boolean) {
      this.showSearchBar = value
    }
  },
})
